import { irrigacao } from './genericos'

const FP = {
  area: '',
  dataInicio: '',
  finalidades: [],
  outrasFinalidades: '',
  especiesFlorestais: [],
  utilizaBioinsumos: '',
  possuiIrrigacao: '',
  financiamentos: [],
  outroFinanciamento: '',
  descricao: '',
  bioinsumos: [],
  irrigacao: {...irrigacao}
}

export default FP



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/FP.js